import React from "react";

// Official YM Studio brand asset — 2026-02-16.
// The image already contains the wordmark ("studio") and its accent bars, so we
// render it as a single integrated composition. Do NOT redraw or reinterpret.
const LOGO_SRC = "/ym-studio-logo.png";
const LOGO_ASPECT = 1.55; // width / height of the official artwork

export function LogoMark({ size = 32, className = "", withGlow = false }) {
  // `size` is the intrinsic height. Width scales from the official aspect ratio.
  const height = size;
  const width = Math.round(size * LOGO_ASPECT);
  return (
    <div className={`relative inline-flex ${className}`} style={{ height, width }}>
      {withGlow && (
        <span
          aria-hidden
          className="absolute inset-0 blur-md opacity-60"
          style={{ background: "linear-gradient(135deg, #2563EB, #38BDF8)" }}
        />
      )}
      <img
        src={LOGO_SRC}
        alt="YM Studio"
        width={width}
        height={height}
        className="relative object-contain"
        draggable={false}
      />
    </div>
  );
}

// Wordmark kept for backwards compatibility with any caller that still imports it.
// The official logo already contains "studio", so we no longer render this by default.
export function Wordmark({ tagline = "", className = "" }) {
  if (!tagline) return null;
  return (
    <div className={`leading-tight ${className}`}>
      <div className="text-[10px] uppercase tracking-[0.18em] text-sky-400 font-medium">{tagline}</div>
    </div>
  );
}

export default function Logo({ compact = false, size = 32, withGlow = false, tagline = "" }) {
  return (
    <div className="flex items-center gap-2.5">
      <LogoMark size={size} withGlow={withGlow} />
      {!compact && tagline && <Wordmark tagline={tagline} />}
    </div>
  );
}
